import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => theme.spacing[4]}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ContainerEscolhaPlanos = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => theme.spacing[2]}px 0px;
  justify-content: space-between;
`;

export const ContainerPlanosAssinaturaTexto = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const ContainerPreviewCatalagoStreaming = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;

  ${({ theme }) => {
    return css`
      gap: ${theme.spacing[2]}px;
      margin: 0 ${theme.spacing[4]}px;
    `;
  }}
`;

export const ContainerCartazesCatalagoStreaming = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;
